import { computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

import { translate, TranslationTokens } from './translate.util';

export type TranslateTokensFn = (tokens: TranslationTokens) => string;

/**
 * Creates a signal that re-resolves whenever the active language changes. Pass translation tokens to resolve a
 * single string, or a `compute` callback — it receives a resolver bound to the current `TranslateService`.
 * Must be called in an injection context
 */
export function translateSignal(tokens: TranslationTokens): Signal<string>;
export function translateSignal<T>(compute: (translateTokens: TranslateTokensFn) => T): Signal<T>;
export function translateSignal<T>(source: TranslationTokens | ((translateTokens: TranslateTokensFn) => T)): Signal<T | string> {
  const translateService = inject(TranslateService);
  const language = toSignal(translateService.onLangChange);

  return computed(() => {
    language();

    const translateTokens = (tokens: TranslationTokens): string => translate(translateService, tokens);

    return typeof source === 'function' ? source(translateTokens) : translateTokens(source);
  });
}
